// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-background: rgba(21, 20, 29, 1);
}

html, body {
  background: var(--primary-background);
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Inter", sans-serif;
  /* background-image: url(); */
  /* background-color: rgb(19, 118, 206); */
}

/* footer,track, home{
    padding: 20px;
} */

/* @media (max-width: 767.98px) {
  header,
  nav,
  main,
  footer {
    padding: 10px;
  }

  nav ul li {
    display: block;
    margin: 5px 0;
  }

  section {
    flex: 1 0 100%;
  }
} */

/* .tracks,
.events,
.FAQs{
  display: flex;
  height: 90vh;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
} */

.container {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1rem;
  padding-right: 1rem;
}

.section {
  padding: 80px 0;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.section__inner {
  max-width: 1200px;
  margin: 0 auto;
  /* padding: 0 20px; */
}

/* Small (sm) */
@media screen and (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}

/* Medium (md) */
@media screen and (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}

/* Large (lg) */
@media screen and (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}

/* Extra Large (xl) */
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}

/* 2XL */
@media screen and (min-width: 1400px) {
  .container {
    max-width: 1320px;
  }
}

.web_container::-webkit-scrollbar,
.hero-container::-webkit-scrollbar,
.beginner_wrapper::-webkit-scrollbar {
  display: none;
}

/* Extra small devices (phones) */
@media screen and (max-width: 576px) {}

/* Small devices (tablets) */
@media screen and (max-width: 768px) {
  .section {
    padding: 60px 0;
  }

  .section--small {
    padding: 30px 0;
  }

  .section--large {
    padding: 90px 0;
  }

  .section__inner {
    padding: 0 16px;
  }
}

/* Medium devices (laptops) */
@media screen and (max-width: 992px) {}

/* Large devices (desktops) */
@media screen and (max-width: 1200px) {}

/* Extra large devices */
@media screen and (max-width: 1400px) {}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;;GAEG;;AAEH;;;;;;;;;;;;;;;;GAgBG;;AAEH;;;;;;;;GAQG;;AAEH;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,gBAAgB;AAChB;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,eAAe;AACf;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,QAAQ;AACR;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;;;EAGE,aAAa;AACf;;AAEA,iCAAiC;AACjC,sCAAsC;;AAEtC,4BAA4B;AAC5B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,6BAA6B;AAC7B,sCAAsC;;AAEtC,6BAA6B;AAC7B,uCAAuC;;AAEvC,wBAAwB;AACxB,uCAAuC","sourcesContent":[":root {\n  --primary-background: rgba(21, 20, 29, 1);\n}\n\nhtml, body {\n  background: var(--primary-background);\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-family: \"Inter\", sans-serif;\n  /* background-image: url(); */\n  /* background-color: rgb(19, 118, 206); */\n}\n\n/* footer,track, home{\n    padding: 20px;\n} */\n\n/* @media (max-width: 767.98px) {\n  header,\n  nav,\n  main,\n  footer {\n    padding: 10px;\n  }\n\n  nav ul li {\n    display: block;\n    margin: 5px 0;\n  }\n\n  section {\n    flex: 1 0 100%;\n  }\n} */\n\n/* .tracks,\n.events,\n.FAQs{\n  display: flex;\n  height: 90vh;\n  align-items: center;\n  justify-content: center;\n  font-size: 3rem;\n} */\n\n.container {\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.section {\n  padding: 80px 0;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n}\n\n.section__inner {\n  max-width: 1200px;\n  margin: 0 auto;\n  /* padding: 0 20px; */\n}\n\n/* Small (sm) */\n@media screen and (min-width: 576px) {\n  .container {\n    max-width: 540px;\n  }\n}\n\n/* Medium (md) */\n@media screen and (min-width: 768px) {\n  .container {\n    max-width: 720px;\n  }\n}\n\n/* Large (lg) */\n@media screen and (min-width: 992px) {\n  .container {\n    max-width: 960px;\n  }\n}\n\n/* Extra Large (xl) */\n@media screen and (min-width: 1200px) {\n  .container {\n    max-width: 1140px;\n  }\n}\n\n/* 2XL */\n@media screen and (min-width: 1400px) {\n  .container {\n    max-width: 1320px;\n  }\n}\n\n.web_container::-webkit-scrollbar,\n.hero-container::-webkit-scrollbar,\n.beginner_wrapper::-webkit-scrollbar {\n  display: none;\n}\n\n/* Extra small devices (phones) */\n@media screen and (max-width: 576px) {}\n\n/* Small devices (tablets) */\n@media screen and (max-width: 768px) {\n  .section {\n    padding: 60px 0;\n  }\n\n  .section--small {\n    padding: 30px 0;\n  }\n\n  .section--large {\n    padding: 90px 0;\n  }\n\n  .section__inner {\n    padding: 0 16px;\n  }\n}\n\n/* Medium devices (laptops) */\n@media screen and (max-width: 992px) {}\n\n/* Large devices (desktops) */\n@media screen and (max-width: 1200px) {}\n\n/* Extra large devices */\n@media screen and (max-width: 1400px) {}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
